module.exports = __webpack_public_path__ + "img/logo_main.d6745470.svg";